// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {flat, resolve} from 'node-resolve-dependency-graph';
import {Module} from "@/modules";
import {injectable} from "inversify";

@injectable()
export class DependencyResolver {
  public resolve(modules: Module[]): Module[] {
    const map = {};
    const namedMap: { [key: string]: Module } = {};

    modules.forEach(module => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      namedMap[module.constructor.getId()] = module;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      map[module.constructor.getId()] = module.dependsOn.map(module => module.getId());
    });

    return flat(resolve(map)).map((name: string) => namedMap[name]);
  }
}